import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import { formatIstDateTime } from "../../utils/datetime";

export default function PayAppTxn() {
  const { id } = useParams();
  const { ApiBaseUrl } = useContext(MyContext);
  const Userid = secureLocalStorage.getItem("Userid");
  const [data, setData] = useState(null);
  const [qr, setQr] = useState("");

  const load = () => {
    axios.post(`${ApiBaseUrl}/pv/customer/txn/detail`, { customer_id: Userid, txn_id: id })
      .then((r) => {
        if (!r.data.Result) return;
        setData(r.data);
        if (r.data.redemption?.qr_payload) {
          setQr(`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(r.data.redemption.qr_payload)}`);
        }
      });
  };

  useEffect(() => { load(); }, [id, Userid, ApiBaseUrl]);

  const refund = async () => {
    const reason = prompt("Refund reason?") || "Customer request";
    const r = await axios.post(`${ApiBaseUrl}/pv/customer/refund`, { customer_id: Userid, txn_id: id, reason });
    toast.info(r.data.message || (r.data.Result ? "Refund requested" : "Failed"));
    load();
  };

  const invoice = async () => {
    const r = await axios.post(`${ApiBaseUrl}/pv/customer/invoice`, { customer_id: Userid, txn_id: id });
    if (r.data.invoice?.file_path) window.open(`${ApiBaseUrl}/${r.data.invoice.file_path}`, "_blank");
    else toast.error("Invoice unavailable");
  };

  if (!data) return <div className="p-10 text-center">Loading...</div>;
  const t = data.txn;

  return (
    <div className="max-w-xl mx-auto px-4 py-8">
      <p className="text-sm text-rm-primary">{t.txn_code}</p>
      <h1 className="text-2xl font-bold">{t.partner_name}</h1>
      <p className="text-gray-600 mb-4">{t.status} · {t.payment_status} · {t.redemption_status}</p>
      <div className="border rounded-xl p-4 bg-white mb-4 space-y-1">
        <p>Bill: ₹{t.original_bill}</p>
        <p>Discount: ₹{t.discount_amount}</p>
        <p className="font-bold">Paid: ₹{t.payable_amount}</p>
        {t.offer_name && <p className="text-sm text-green-700">Offer: {t.offer_name}</p>}
      </div>
      {data.redemption && t.payment_status === "paid" && (
        <div className="border rounded-xl p-4 bg-white mb-4 text-center">
          <h3 className="font-semibold mb-2">Redemption code</h3>
          <p className="text-3xl font-bold tracking-widest mb-3">{data.redemption.code}</p>
          {qr && <img src={qr} alt="QR" className="mx-auto w-48 h-48" />}
          <p className="text-xs text-gray-500 mt-2">Show this at the partner before expiry</p>
        </div>
      )}
      <div className="flex flex-wrap gap-3">
        {t.payment_status === "paid" && <button className="bg-rm-primary text-white px-4 py-2 rounded" onClick={invoice}>Invoice PDF</button>}
        {t.payment_status === "paid" && t.redemption_status !== "redeemed" && (
          <button className="bg-red-600 text-white px-4 py-2 rounded" onClick={refund}>Request refund</button>
        )}
      </div>
      <ol className="mt-6 space-y-2">
        {(data.history || []).map((h) => (
          <li key={h.id} className="text-sm border-l-2 border-[#0d9488] pl-3">
            <b>{h.to_status}</b>
            <div className="text-gray-500">{formatIstDateTime(h.created_at)}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}
